import styled, { ITheme } from '../../../theme'
import { IWithSize } from '../../../containers/BookingCalendar/Calendar/Calendar'

const GroupTitle = styled.div<IWithSize>`
  font-size: ${({ size }) => (size ? 14 * size : 14)}px;
  margin-top: ${({ size }) => (size ? 20 * size : 20)}px;
  margin-bottom: ${({ size }) => (size ? 10 * size : 10)}px;
  font-weight: 600;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: left;
  color: ${(props: ITheme) => props.theme.colors.palette.slateGrey};
`

export default GroupTitle
